var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldDeviceMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.348 14.069 14.09 15.58c-.36.24-.78.35-1.19.35-.35 0-.7-.08-1.02-.26-.7-.37-1.13-1.19-1.13-1.98-.74-.22-1.4-.6-1.92-1.12-.86-.86-1.33-2.07-1.33-3.42V5a1 1 0 0 0-1-1C3.8 4 2 5.35 2 8.5v5.4c0 3.15 1.8 4.5 4.5 4.5h3.75v2.85H7.4c-.41 0-.75.34-.75.75s.34.75.75.75h7.2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.85V18.4h3.75c2.7 0 4.5-1.35 4.5-4.5h-3.096a1 1 0 0 0-.556.169z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2c-1.49 0-2.61.76-3.05 2-.13.38-.2.8-.2 1.25v3.9c0 .97.32 1.79.89 2.36.57.57 1.39.89 2.36.89v1.39c0 .51.58.82 1.01.54l2.89-1.93h2.6c.45 0 .87-.07 1.25-.2 1.24-.44 2-1.56 2-3.05v-3.9C22 3.3 20.7 2 18.75 2h-6.5zm-.38 5.25a.749.749 0 1 1 1.5 0 .749.749 0 1 1-1.5 0zm2.82 0c0-.41.34-.75.75-.75s.75.34.75.75-.34.75-.75.75c-.42 0-.75-.34-.75-.75zm2.81 0c0-.41.34-.75.75-.75s.75.34.75.75-.34.75-.75.75c-.42 0-.75-.34-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 9.15c0 1.49-.76 2.61-2 3.05-.38.13-.8.2-1.25.2h-2.6l-2.89 1.93c-.43.28-1.01-.03-1.01-.54V12.4c-.97 0-1.79-.32-2.36-.89-.57-.57-.89-1.39-.89-2.36v-3.9c0-.45.07-.87.2-1.25.44-1.24 1.56-2 3.05-2h6.5C20.7 2 22 3.3 22 5.25v3.9z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldDeviceMessage);
export default __webpack_public_path__ + "static/media/vuesax-bold-device-message.4494528a1253159f98004edf3187832a.svg";
export { ForwardRef as ReactComponent };